// src/AppRouter.tsx
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { publicRoutes } from "./routes";

const AppRouter: React.FC = () => {
  return (
    <Router>
      <Routes>
        {/* Rutas Públicas */}
        {publicRoutes.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={route.element}
          />
        ))}

        {/* Rutas Privadas */}
        {/* {privateRoutes.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={
              localStorage.getItem("token") ? route.element : <Navigate to="/login" />
            }
          />
        ))} */}

        {/* Ruta por defecto */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
};

export default AppRouter;
